import React, { useState, useEffect } from "react";
import axiosInstance from "../../services/auth";
import "./Employee.css";
import { toast } from "react-toastify";

const EmployeeForm = ({
  selectedCompany,
  companyId,
  companyCode,
  employee,
  onClose,
  // vessel,
}) => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState(
    employee
      ? {
          ...employee,
          dateOfJoin: employee.dateOfJoin
            ? new Date(employee.dateOfJoin).toISOString().split("T")[0]
            : "",
          expiryDate: employee.expiryDate
            ? new Date(employee.expiryDate).toISOString().split("T")[0]
            : "",
        }
      : {
          companyId: companyId,
          name: "",
          employeeNo: "",
          status: true,
          address: "",
          dateOfJoin: "",
          expiryDate: "",
          bankName: "",
          AccountNo: "",
          loanAmount: 0,
          foodAllowance: 0,
        }
  );
  // console.log("employee", employee);
  const sanitizeFormData = (data) => {
    const sanitizedData = { ...data };

    // Remove unwanted fields
    delete sanitizedData.locationSearch;
    delete sanitizedData.showLocationDropdown;
    delete sanitizedData.showVesselDropdown;
    delete sanitizedData.vesselSearch;

    return sanitizedData;
  };

  // console.log("form data", formData);
  // Make sure to correctly set the value of `company_code`
  

  
  // console.log("employee form ",formData)
  const handleOutsideClick = (e) => {
    if (e.target.classList.contains("modal")) {
      onClose();
    }
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if the selected company is inactive
    if (selectedCompany?.status === false) {
      toast.error("The company is not active");
      return;
    }

    // Start loading state for the button or form
    setLoading(true);

    // Sanitize form data before sending it
    const sanitizedData = sanitizeFormData(formData);
    //  console.log("sanitized data", sanitizedData);

    try {
      // Determine whether to update an existing employee or create a new one
      if (employee) {
        const response = await axiosInstance.patch(
          `/employee/${employee._id}`,
          sanitizedData
        );

        // If the response has a specific error code, throw an error to be caught in the catch block
        if (response.data.statusCode === 400) {
          throw { response: { data: { message: response.data.message[0] } } };
        }
      } else {
        const response = await axiosInstance.post("/employee", sanitizedData);

        // If the response has a specific error code, throw an error to be caught in the catch block
        if (response.data.statusCode === 400) {
          throw { response: { data: { message: response.data.message[0] } } };
        }
      }

      // Close modal after successful submission
      onClose();
      toast.success(
        employee
          ? "Employee updated successfully"
          : "Employee created successfully"
      );
    } catch (error) {
      // If there is an error, show a toast with the error message
      toast.error(error.response?.data?.message || "Error saving employee");
    } finally {
      // Stop loading state when the process is complete (either success or error)
      setLoading(false);
    }
  };

  const authData =
    JSON.parse(localStorage.getItem("authData")) ||
    JSON.parse(sessionStorage.getItem("authData"));

  const userRole = authData.role;



  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      onClick={handleOutsideClick}
      style={{ display: "block", backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div className="modal-content employee_model">
          <div className="modal-header text-white text-center vesel_form">
            <h5 className="modal-title">
              {employee ? "Edit Employee" : "Add Employee"}
            </h5>
            <button
              type="button"
              className="btn-close text-white"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body vesel_form">
            <form onSubmit={handleSubmit}>
              {/* Employee Details Section */}
              <div className="card shadow-sm mb-4 rounded-3">
                <div className="card-body">
                  <h5 className="card-title text-center mb-4">
                    Employee Details
                  </h5>
                  <div className="row">
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Employeee Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </div>

                   
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Employee No</label>
                      <input
                        type="text"
                        className="form-control"
                        name="employeeNo"
                        value={formData.employeeNo}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Status</label>
                      <select
                        className="form-select"
                        name="status"
                        value={formData.status ? "true" : "false"}
                        onChange={(e) => setFormData((prev) => ({ ...prev, status: e.target.value === "true" }))}
                        required
                      >
                        <option value="true">Active</option>
                        <option value="false">Inactive</option>
                      </select>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Date of Join</label>
                      <input
                        type="date"
                        className="form-control"
                        name="dateOfJoin"
                        value={formData.dateOfJoin}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Expire Date</label>
                      <input
                        type="date"
                        className="form-control"
                        name="expiryDate"
                        value={formData.expiryDate}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Address</label>
                      <textarea
                        className="form-control"
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        rows="1"
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Bank Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="bankName"
                        value={formData.bankName}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Account No</label>
                      <input
                        type="text"
                        className="form-control"
                        name="AccountNo"
                        value={formData.AccountNo}
                        onChange={handleChange}
                        required
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Loan Amount</label>
                      <input
                        type="number"
                        className="form-control"
                        name="loanAmount"
                        value={formData.loanAmount}
                        onChange={handleChange}
                        min="0"
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label className="form-label">Food Allowance</label>
                      <input
                        type="number"
                        className="form-control"
                        name="foodAllowance"
                        value={formData.foodAllowance}
                        onChange={handleChange}
                        min="0"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-4 text-center">
                <button type="submit" className="button-2" disabled={loading}>
                  {loading
                    ? employee
                      ? "Updating"
                      : "Creating"
                    : employee
                    ? "Update Employee"
                    : "Add employee"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeForm;
